
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import { getMonthlyWaitAverages } from '../../lib/dbFetcher';
import { slugFromMonth } from '../../lib/securityWaitByMonth';
const formatHour = (h) => h == null ? null : `${String(h).padStart(2, '0')}:00`;
async function getStaticProps() {
    let months = [];
    try {
        months = await getMonthlyWaitAverages();
    }
    catch (error) {
        console.error('Error building security-wait hub:', error);
        months = Array.from({ length: 12 }, (_, i) => ({
            month: i + 1,
            avgLow: null,
            busiestHour: null
        }));
    }
    return { props: { months }, revalidate: 3600 };
}
function SecurityWaitHub({ months }) {
    const { t } = useTranslation('security-wait');
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('hub_meta_title')}</title>
                <meta name="description" content={t('hub_meta_description')}/>
                <meta name="robots" content="all"/>
                <meta property="og:title" content={t('hub_meta_title')}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">{t('hub_title')}</h1>
            <p className="mt-3 text-gray-600">{t('hub_intro')}</p>

            <table className="mt-6 w-full text-left border-collapse">
                <thead>
                    <tr className="border-b">
                        <th className="py-2">{t('col_month')}</th>
                        <th className="py-2">{t('col_avg')}</th>
                        <th className="py-2">{t('col_busiest')}</th>
                    </tr>
                </thead>
                <tbody>
                    {months.map((m) => (<tr key={m.month} className="border-b">
                            <td className="py-2">
                                <Link href={`/security-wait/${slugFromMonth(m.month)}`} className="text-[var(--secondary)] underline">
                                    {t(`month_${m.month}`)}
                                </Link>
                            </td>
                            <td className="py-2">
                                {m.avgLow != null ? m.avgLow : '-'}
                            </td>
                            <td className="py-2">
                                {formatHour(m.busiestHour) || '-'}
                            </td>
                        </tr>))}
                </tbody>
            </table>

            <p className="mt-4 text-xs text-gray-500">{t('source_note')}</p>

            <div className="mt-6 flex flex-col gap-2">
                <Link href="/" className="text-[var(--secondary)] underline">
                    {t('cta_live')}
                </Link>
                <Link href="/travel-times" className="text-[var(--secondary)] underline">
                    {t('cta_weekday')}
                </Link>
                <Link href="/best-time-to-arrive" className="text-[var(--secondary)] underline">
                    {t('cta_best_time')}
                </Link>
            </div>
        </div>);
}
export default SecurityWaitHub;

    async function __Next_Translate__getStaticProps__1a1723ec747__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/security-wait/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec747__ as getStaticProps }
  